<script lang="ts" setup>
import NotifyToggle from "@src/components/ui/inputs/NotifyToggle.vue";

const props = defineProps<{
    value: string;
    title: string;
    description: string;
}>();
</script>

<template>
    <div class="w-full flex flex-col">
        <div class="flex">
            <!--label-->
            <div class="grow">
                <label
                    class="inline-block outline-none mb-4"
                    for="last-seen"
                    tabindex="0"
                >
                    <p class="heading-2 text-black/70 dark:text-white/70 w-13">
                        {{ props.title }}
                    </p>
                </label>
            </div>

            <NotifyToggle :type="props.value"/>

            <!--switch-->
        </div>
        <!--description or help text-->
        <p
            class="body-2 text-black/70 dark:text-white/70 help-block outline-none"
            tabindex="0"
        >
            {{ props.description }}
        </p>
    </div>
</template>
